var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackspace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6684 6.90918L10.8015 13.776M17.6684 13.776L10.8015 6.90918L17.6684 13.776Z",
    stroke: "#353535",
    strokeWidth: 1.44565,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.68117 2.1021C6.89438 1.81782 7.17085 1.58709 7.48868 1.42817C7.80651 1.26926 8.15698 1.18652 8.51233 1.18652H21.1016C21.7086 1.18652 22.2908 1.42768 22.7201 1.85694C23.1493 2.2862 23.3905 2.86841 23.3905 3.47547V17.2092C23.3905 17.8162 23.1493 18.3984 22.7201 18.8277C22.2908 19.257 21.7086 19.4981 21.1016 19.4981H8.51233C8.15698 19.4981 7.80651 19.4154 7.48868 19.2565C7.17085 19.0976 6.89438 18.8668 6.68117 18.5825L1.53103 11.7157C1.23388 11.3195 1.07324 10.8376 1.07324 10.3423C1.07324 9.84706 1.23388 9.36516 1.53103 8.96895L6.68117 2.1021V2.1021Z",
    stroke: "#353535",
    strokeWidth: 1.44565,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackspace);
export default __webpack_public_path__ + "static/media/backspace.ab35c92a001ce98a3202a6fabe4d3216.svg";
export { ForwardRef as ReactComponent };